import React, { Component, Suspense } from 'react';
import { connect, Provider } from 'react-redux';
import store from 'react/redux/store/store';
import * as popupActions from '../redux/actions/popups';

import { bindActionCreators } from 'redux';
import StreamPopupCard from './StreamPopupCard';
import OutsideAlerter from '../elements/OutsideAlerter';
import KeepOnScreenPositioner from '../elements/KeepOnScreenPositioner';
import PopupTypes from '../../components/PopupTypes';
import ContextMenuContainer from '../elements/ContextMenuContainer';
import RoomMenu from 'react/chat/rooms/RoomMenu';
import { showChatRules } from 'react/redux/actions/chat';
import CardSkeleton from 'react/profile/card/CardSkeleton';

const ProfileCard = React.lazy(() => import(/* webpackChunkName: "ProfileCard" */ 'react/profile/card/ProfileCard'));

class PopupCards extends Component {
	render() {
		const {
			activePopupUser: user,
			activePopupStream: stream,
			activePopupChatMessage: chatMessage,
			activePopupPreferredGameFilter: preferredGameFilter,
			activePopupType: type,
			activePopupCoordinates: coordinates,
			activePopupChatRoomId,
			activePopupChatRoom: chatRoom,
			activePopupRoomMenu: roomMenu,
			resizeTriggerIndex,
			popupResizeProbablyHappened,
			closePopup,
			userClickPopupOpen,
		} = this.props;
		if(!coordinates) {
			return null;
		}
		const popupProps = {
			startPosition: coordinates,
			resizeTriggerIndex: resizeTriggerIndex,
		};
		const popupControlProps = {
			closePopup,
			popupResizeProbablyHappened,
		};
		switch(type) {
			case PopupTypes.STREAM_POPUP:
				return (
					<OutsideAlerter>
						<KeepOnScreenPositioner
							{...popupProps}
							minHeight={206}
							rounded={true}
						>
							<StreamPopupCard
								{...popupControlProps}
								activePopup={stream}
								{...this.props}
							/>
						</KeepOnScreenPositioner>
					</OutsideAlerter>
				);
			case PopupTypes.PROFILE_CARD: {
				return (
					<OutsideAlerter>
						<KeepOnScreenPositioner
							{...popupProps}
							minHeight={206}
							className='popout_card--profile-card'
						>
							<Provider store={store}>
								<Suspense fallback={<CardSkeleton player={user} />}>
									<ProfileCard
										key={user ? user.id || user.username : 'none'}
										{...popupProps}
										{...popupControlProps}
										player={user}
									/>
								</Suspense>
							</Provider>
						</KeepOnScreenPositioner>
					</OutsideAlerter>
				);
			}
			case PopupTypes.FRIEND_LIST_POPUP:
			case PopupTypes.CHAT_MESSAGE_MENU:
			case PopupTypes.GAME_FILTER_CONTEXT_MENU: {
				return (
					<OutsideAlerter>
						<KeepOnScreenPositioner
							{...popupProps}
							minHeight={206}
						>
							<Provider store={store}>
								<ContextMenuContainer
									{...popupControlProps}

									preferredGameFilter={preferredGameFilter}
									chatMessage={chatMessage}
									player={user}
									showFriendOptionsOnly={type === PopupTypes.FRIEND_LIST_POPUP}
									startPosition={popupProps.startPosition}
									userClickPopupOpen={userClickPopupOpen}
								/>
							</Provider>
						</KeepOnScreenPositioner>
					</OutsideAlerter>
				);
			}
			case PopupTypes.ROOM_MENU: {
				return (
					<OutsideAlerter>
						<KeepOnScreenPositioner
							{...popupProps}
							minHeight={206}
						>
							<RoomMenu
								key={chatRoom.id}
								room={chatRoom}
								index={roomMenu.index}
								total={roomMenu.total}
								onMove={roomMenu.onMove}
								onOpenRoom={roomMenu.onOpenRoom}
								onShowRules={() => store.dispatch(showChatRules())}
								closePopup={closePopup}
							/>
						</KeepOnScreenPositioner>
					</OutsideAlerter>
				);
			}
			default:
				return null;
		}
	}
}

function mapStateToProps(state) {
	return {
		...state.popups,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		...popupActions,
	}, dispatch);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PopupCards);